import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { MEAL_PLANNING_PATH, MODAL_ROUTES, RECIPES_PATH } from '@woolworthsnz/shop';
import { Observable } from 'rxjs';
import { take, tap } from 'rxjs/operators';
import { MealPlanningData } from '../../models';
import { MealPlanningService } from '../../services/meal-planning.service';

@Injectable({
	providedIn: 'root',
})
export class ChooseMealPlanResolverService {
	constructor(private mealPlanningService: MealPlanningService, private router: Router) {}

	resolve(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<MealPlanningData | undefined> {
		return this.mealPlanningService.loadMealPlanningData().pipe(
			take(1),
			tap((mealPlanningData) => {
				const chooseMealPlanFullPath = `/${MEAL_PLANNING_PATH}/(${MODAL_ROUTES.MEAL_PLANNING_MODAL}:${MODAL_ROUTES.MEAL_PLANNING_CHOOSE_PLAN_PATH})`;
				if (
					!this.mealPlanningService.hasCompletedPreferences(mealPlanningData.preferences) &&
					state.url !== chooseMealPlanFullPath &&
					state.url !== `/${MEAL_PLANNING_PATH}` &&
					!state.url.includes(RECIPES_PATH)
				) {
					this.router.navigate([MEAL_PLANNING_PATH]);
				}
			})
		);
	}
}
